// Adding a label above the cart drawer quantity-selector input for ADA compatibility
document.addEventListener('DOMContentLoaded', () => {
  setTimeout(()=>{
    quantitySelectors = document.querySelectorAll('.main-bottom .quantity-selector');

    if(quantitySelectors.length === 0) {
      // console.warn("No cart quantity selectors found..");
    } else {
      let selectorIndex = 0;
      quantitySelectors.forEach(selector => {
        const input = selector.querySelector('input[type="text"]');
        console.log("Input: " + input);
        if (input) {
            const label = document.createElement('label');
            label.textContent = 'Quantity:';
            label.setAttribute('for', 'drawer-quantity-input_' + selectorIndex);
            label.classList.add('sr-only');
    
            if (!input.id) {
                input.id = ('drawer-quantity-input_' + selectorIndex);
            }
    
            selector.insertBefore(label, input);
        }
        selectorIndex++;
      });
    }
  }, 500);
});